/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {PauseNeighborhoodProgramRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {PauseNeighborhoodProgramResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const pauseNeighborhoodProgram = (request: PauseNeighborhoodProgramRequest, options?: CashRequestOptions) => post<PauseNeighborhoodProgramRequest, PauseNeighborhoodProgramResponse>("/2.0/cash/pause-neighborhood-program", request, {...options, rejectOnError: true })